import { render, staticRenderFns } from "./SellerOfferBiddingDetails.vue?vue&type=template&id=0a03195d&scoped=true"
import script from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"
export * from "./SellerOfferBiddingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03195d",
  null
  
)

export default component.exports